import * as React from "react";

import { Button } from "@/shadcn/components/ui/button";
import { cn } from "@/shadcn/lib/utils";

const TableSortButton = React.forwardRef(function TableSortButton(
  { active = false, className, type = "button", ...props },
  ref
) {
  return (
    <Button
      ref={ref}
      {...props}
      type={type}
      variant="ghost"
      size="sm"
      data-slot="table-sort-button"
      data-active={active ? "" : undefined}
      className={cn(
        "justify-start text-left text-muted-foreground data-[active]:text-foreground",
        className
      )}
    />
  );
});

TableSortButton.displayName = "TableSortButton";

export { TableSortButton };
